import {
  ANGLE_ROT_WARP,
  RADIUS_GALAXY,
  MAX_WARP_ANGLE,
  WAVE_START,
} from '../configEntities/galaxyConfig.js'

export function updateSize(sizeSet, element) {
    const sizes = element.objects.geometry.attributes.sizes.array
  
    for (let i = 0; i < sizes.length; i++) {
      sizes[i] = sizeSet * element.attributes.sizes[i]
    }
    element.objects.geometry.attributes.sizes.needsUpdate = true
  }

export function animateParts(points, speedGlobal, speeds) {

  let partPos = points.geometry.attributes.position.array;

  for (let i = 0; i < partPos.length; i += 3) {
    let radius = Math.sqrt(
      (partPos[i]) ** 2 + (partPos[i + 2] ) ** 2,
    );
    const orbitalAngle = Math.atan2(
      partPos[i + 2] ,
      partPos[i],
    );

    const speed = (-speedGlobal * speeds[i / 3]) / Math.sqrt(radius, 2);
    const theta = (orbitalAngle + speed)%(Math.PI*2);

    partPos[i] =  radius * Math.cos(theta);
    partPos[i + 2] =  radius * Math.sin(theta);

  }
  points.material.needsUpdate = true;
  points.geometry.attributes.position.needsUpdate = true;
}


export function animatePartsGalaxy(
  points, speed, warpPhase, speeds, basePos 
) {
  const positions = points.geometry.attributes.position.array;

  for (let i = 0; i < positions.length; i += 3) {
    const x0 = basePos[i], 
          y0 = basePos[i + 1], 
          z0 = basePos[i + 2];

    const dx = x0, 
          dz = z0;
    const radius       = Math.hypot(dx, dz);
    const orbitalAngle0 = Math.atan2(dz, dx);
    const theta = orbitalAngle0 + speeds[i/3] * speed;

    positions[i]     = radius * Math.cos(theta);
    positions[i + 2] = radius * Math.sin(theta);

    let y = y0;
    if (radius > WAVE_START) {
      const t         = (radius - WAVE_START) / (RADIUS_GALAXY - WAVE_START);
      const bendAngle = t * MAX_WARP_ANGLE;
      const off       = Math.sin(bendAngle) * (RADIUS_GALAXY * t);
      const phase     = (orbitalAngle0 + warpPhase + ANGLE_ROT_WARP) % (Math.PI * 2);
      y += off * Math.cos(phase);
    }

    positions[i + 1] = y;

    basePos[i]   = positions[i];
    basePos[i+2] = positions[i+2];
  }

  points.geometry.attributes.position.needsUpdate = true;
}
